<custom-modal-card [enableClose]="false" class="admin-migration-modal">
  <ng-container body>
    <section class="admin-migration-modal__header">
      <img src="assets/icons/logo.png" alt="Logo FNE" />
      <h2>Bienvenue sur la nouvelle plateforme fne v2 !</h2>
    </section>
    <article class="admin-migration-modal__content">
      <section class="admin-migration-modal__greeting">
        <p>
          Bonjour <strong>{{ managerName() }}</strong>
        </p>
        <p>
          En tant que gestionnaire principal de
          <strong>{{ organizationName() }}</strong
          >, nous vous informons que votre entreprise a été migrée avec succès
          vers la nouvelle plateforme FNE V2.
        </p>
      </section>
      <section class="admin-migration-modal__features">
        <h3>Quelles nouveautés dans la FNE V2 ?</h3>
        <p>La nouvelle plateforme vous offre des avantages significatifs :</p>
        <ul class="admin-migration-modal__features-list">
          <li>
            <span class="icon">✨</span> Interface modernisée et plus intuitive
          </li>
          <li>
            <span class="icon">✨</span> Prise en charge des débours et des
            ristournes
          </li>
          <li>
            <span class="icon">✨</span> Traçabilité et expérience améliorée des
            paiements de stickers
          </li>
          <li>
            <span class="icon">✨</span> Nouvelles options de gestion
            multi-utilisateurs
          </li>
          <li>
            <span class="icon">✨</span> Sécurité renforcée et intégration API
            améliorée pour vos systèmes
          </li>
        </ul>
      </section>
      <section class="admin-migration-modal__notice">
        <p class="highlight">
          <strong>Votre action est importante</strong> pour finaliser la
          migration et permettre à tous vos utilisateurs d'accéder à la
          plateforme FNE V2, vous devez compléter obligatoirement les
          informations de votre entreprise.
        </p>

        <p class="note">
          <strong>Rappel important :</strong> cette opération est exclusivement
          réservée au gestionnaire principal. Toutes vos données (factures,
          clients, historiques) ont été migrées en toute sécurité sans aucun
          risque de perte et vos anciens identifiants restent pleinement
          valides.
        </p>
      </section>
      <section class="admin-migration-modal__help">
        <h4>Besoin d'aide ?</h4>
        <address class="admin-migration-modal__contact">
          <p>
            📞 Contactez notre support :
            <strong>
              <strong>
                <a
                  href="tel:2521018660"
                  target="_blank"
                  rel="noopener noreferrer"
                  >25 21 01 86 60</a
                >
              </strong>
            </strong>
          </p>
          <p>
            📧 Email :
            <strong>
              <a
                href="mailto:support.fne@dgi.gouv.ci"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ 'support.fne@dgi.gouv.ci' }}
              </a>
            </strong>
          </p>
        </address>
      </section>
    </article>
  </ng-container>

  <ng-container footer>
    <div class="admin-migration-modal__actions">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="goToOnboardingMigration()"
      >
        J'ai compris, aller à la configuration
      </button>
    </div>
  </ng-container>
</custom-modal-card>
